import { useState } from "react";
import UserContext from "./userContext";

const UserContextProvider = ({ children }) => {
    let userData;
    if (localStorage.getItem('siteUser')) {
        userData = localStorage.getItem('siteUser')
    } else {
        userData = localStorage.getItem('user')
    }
    const [user, setUser] = useState(userData)
    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    )
};

export default UserContextProvider;